import React from 'react';
import {
    ItemsNotAllowedText,
    ExclusionItemsNotAllowedDiv,
    ItemTitle,
    Description,
    ButtonFooter,
    ProductsContainer,
} from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { hideScrolling, resumeScrolling } from 'src/utils/util';
import { useTranslation } from 'react-i18next';

//44
const AccountOrSurgeonError = ({
    onClose,
    productsNotAddedToCart = [],
    message,
    title,
}) => {
    const { t } = useTranslation();
    const formatProductString = (productString) => {
        try {
            const [productCFN, ...descriptionParts] =
                productString.split(' - ');

            return {
                productCFN: productCFN?.trim() || '',
                description: descriptionParts.join(' - ')?.trim() || '',
                original: productString,
            };
        } catch (error) {
            return {
                productCFN: [],
                description: [],
                original: productString,
            };
        }
    };
    const products = productsNotAddedToCart && productsNotAddedToCart !==undefined && productsNotAddedToCart?.map((product) =>
        formatProductString(product)
    );
    return (
        <>
            <Popup
                title={title}
                id={'surgery-productAddMethod-accountOrSurgeonError-popup'}
                style={{ display: 'block' }}
                hideIcon
                margin
                emptyCartWidth={'450px'}
                colortitle={'#170F5F'}
                titleFontWeight={'600'}
                titleFontFamily={'AvenirNextWorld Regular'}
                impersonationBackground={'rgb(47, 45, 70, 0.53)'}
            >
                <ExclusionItemsNotAllowedDiv
                    width={'auto'}
                    mbHeight={'auto'}
                    height={'auto'}
                >
                    <ItemsNotAllowedText
                        height={'auto'}
                        margin={'15px 0 5% 0'}
                        fontFamily={'AvenirNextWorld Regular'}
                        fontWeight={'400'}
                    >
                        {message}
                    </ItemsNotAllowedText>
                    <ProductsContainer
                        isProductTemplateExclusionItems={true}
                        onPointerMove={resumeScrolling}
                        onTouchMove={resumeScrolling}
                        onTouchEnd={hideScrolling}
                        scrollBarWidth={'5px'}
                        scrollBarBackgroundColor={'#888'}
                        scrollBarBorderRadius={'10px'}
                        scrollbarHeight={'2rem'}
                        scrollBarBackGroundColorOnHover={'#555'}
                        mobileDeviceScrollBarDisplay={'block'}
                        mediumDeviceScrollBarDisplay={'block'}
                    >
                        {products?.length > 0 &&
                            products?.map((product, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        fontSize: '14px',
                                        color: '#170F5F',
                                        fontFamily: 'AvenirNextWorld Regular',
                                        fontWeight: '400',
                                    }}
                                >
                                    <ItemTitle
                                        flexBasis={'none'}
                                        key={index}
                                        color={'#170F5F'}
                                        fontFamily={'AvenirNextWorld Regular'}
                                        fontWeight={'600'}
                                    >
                                        {`${product.productCFN} - `}&nbsp;
                                    </ItemTitle>
                                    <Description flexBasis={'none'}>
                                        {product?.description?.length
                                            ? ` ${
                                                  product.description[0] +
                                                  product.description
                                                      .slice(1)
                                                      .toLowerCase()
                                              }`
                                            : ''}
                                    </Description>
                                </div>
                            ))}
                    </ProductsContainer>
                </ExclusionItemsNotAllowedDiv>
                <ButtonFooter
                    showCancelButton={true}
                    center={true}
                    mbPosition={'relative'}
                >
                    <Button
                        id={'surgery-notifications-accountorsurgeon-errorclose'}
                        show={true}
                        width={'150px'}
                        height={'36px'}
                        // primary={true}
                        variant={ButtonStyles?.primary}
                        margin={'5px'}
                        fontSize={'14px'}
                        clicked={onClose}
                    >
                        {t('accounts.accountFilter.close')}
                    </Button>
                </ButtonFooter>
            </Popup>
        </>
    );
};

export default AccountOrSurgeonError;
